import { onMounted, useContext } from '@nuxtjs/composition-api';
import useCart from '~/modules/checkout/composables/useCart';
import cartGetters from '~/modules/checkout/getters/cartGetters';
import useOmnibusPrice from '~/modules/catalog/product/composables/useOmnibusPrice';

export const loadCartMixin = () => {
  const { load, cart } = useCart();
  const { app } = useContext();
  const { getOmnibusPrices } = useOmnibusPrice();

  const cartId = app.$vsf.$magento.config.state.getCartId();

  onMounted(async () => {
    if (cartId) {
      await load();
      const products = cartGetters.getItems(cart.value).filter(Boolean);
      if (products.length > 0) {
        await getOmnibusPrices(products);
      }
    }
  });
};
